(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9630],{

/***/ 11994:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/live/[cid]",
      function () {
        return __webpack_require__(37840);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 37840:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var src_components_layouts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75519);
/* harmony import */ var html_react_parser__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25935);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2962);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var pages_404__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(31788);
/* harmony import */ var src_components_cards_video_card_v__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(62732);
/* harmony import */ var src_components_sections_section_video_sec_full_h__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(4263);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(15072);
/* harmony import */ var src_constants_layout__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(38864);
/* harmony import */ var src_services_member_auth_utils_decryption_payload__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(84233);
/* harmony import */ var src_utils_datalayer_send_datalayer__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(34892);
/* harmony import */ var src_utils_device__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(25283);
/* harmony import */ var src_utils_helper__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(39334);
/* harmony import */ var src_utils_useUser__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(51148);



// import client from 'src/utils/client';















var PageVideoCategory = function(param) {
    var _dataLive = param.dataLive, dataLive = _dataLive === void 0 ? null : _dataLive, dataAdsHeader = param.dataAdsHeader;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
    var _data = (0,src_utils_useUser__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)();
    var sessionSevId = (_data === null || _data === void 0 ? void 0 : _data.user) ? (0,src_services_member_auth_utils_decryption_payload__WEBPACK_IMPORTED_MODULE_12__/* .decryptionClient */ .F)(_data === null || _data === void 0 ? void 0 : _data.user) : null;
    if (lodash__WEBPACK_IMPORTED_MODULE_3___default().isEmpty(dataLive)) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pages_404__WEBPACK_IMPORTED_MODULE_7__["default"], {
        dataAdsHeader: dataAdsHeader,
        sessionSevId: sessionSevId
    });
    var dataConcat1 = (dataLive === null || dataLive === void 0 ? void 0 : dataLive.block1.data) || [];
    var dataConcat2 = (dataLive === null || dataLive === void 0 ? void 0 : dataLive.block2.data) || [];
    var dataConcat3 = (dataLive === null || dataLive === void 0 ? void 0 : dataLive.block3.data) || [];
    var dataConcat4 = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(new Set(dataConcat1.concat(dataConcat2).concat(dataConcat3)));
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)();
    var baseUrlCategory = "".concat(src_constants__WEBPACK_IMPORTED_MODULE_10__/* .APP_URL */ .FX).concat(router.asPath);
    var articleDescriptionSeo = (0,src_utils_helper__WEBPACK_IMPORTED_MODULE_15__/* .escapeChar */ .yf)((ref = dataLive.metaTag) === null || ref === void 0 ? void 0 : ref.description) || src_constants_layout__WEBPACK_IMPORTED_MODULE_11__/* .WEB_DESC */ .a0;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_4__/* .NextSeo */ .PB, {
                noindex: src_constants__WEBPACK_IMPORTED_MODULE_10__/* .IS_NO_ROBOT_INDEX */ .wn,
                nofollow: src_constants__WEBPACK_IMPORTED_MODULE_10__/* .IS_NO_ROBOT_INDEX */ .wn,
                title: ((ref1 = dataLive.metaTag) === null || ref1 === void 0 ? void 0 : ref1.title) ? "".concat((ref2 = dataLive.metaTag) === null || ref2 === void 0 ? void 0 : ref2.title) : src_constants_layout__WEBPACK_IMPORTED_MODULE_11__/* .WEB_TITLE */ .qN,
                description: ((ref3 = dataLive.metaTag) === null || ref3 === void 0 ? void 0 : ref3.description) || src_constants_layout__WEBPACK_IMPORTED_MODULE_11__/* .WEB_DESC */ .a0,
                robotsProps: {
                    maxImagePreview: "large",
                    maxSnippet: -1,
                    maxVideoPreview: -1
                },
                openGraph: {
                    type: "article",
                    locale: "th_TH",
                    site_name: src_constants_layout__WEBPACK_IMPORTED_MODULE_11__/* .WEB_NAME */ .Ey,
                    title: ((ref4 = dataLive.metaTag) === null || ref4 === void 0 ? void 0 : ref4.title) ? "".concat((ref5 = dataLive.metaTag) === null || ref5 === void 0 ? void 0 : ref5.title) : src_constants_layout__WEBPACK_IMPORTED_MODULE_11__/* .WEB_TITLE */ .qN,
                    description: ((ref6 = dataLive.metaTag) === null || ref6 === void 0 ? void 0 : ref6.description) || src_constants_layout__WEBPACK_IMPORTED_MODULE_11__/* .WEB_DESC */ .a0,
                    url: baseUrlCategory,
                    images: [
                        {
                            url: src_constants_layout__WEBPACK_IMPORTED_MODULE_11__/* .IMAGE_DEFAULT */ .TH,
                            width: "1920",
                            height: "1080",
                            alt: src_constants_layout__WEBPACK_IMPORTED_MODULE_11__/* .WEB_NAME */ .Ey
                        }
                    ]
                },
                additionalMetaTags: [
                    {
                        name: "keywords",
                        content: ((ref7 = dataLive.metaTag) === null || ref7 === void 0 ? void 0 : ref7.keyword) || src_constants_layout__WEBPACK_IMPORTED_MODULE_11__/* .WEB_KEYWORD */ .kG
                    }
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_5___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        href: baseUrlCategory
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "twitter:title",
                        content: ((ref8 = dataLive.metaTag) === null || ref8 === void 0 ? void 0 : ref8.title) ? "".concat((ref9 = dataLive.metaTag) === null || ref9 === void 0 ? void 0 : ref9.title) : src_constants_layout__WEBPACK_IMPORTED_MODULE_11__/* .WEB_TITLE */ .qN
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "twitter:description",
                        content: ((ref10 = dataLive.metaTag) === null || ref10 === void 0 ? void 0 : ref10.description) || src_constants_layout__WEBPACK_IMPORTED_MODULE_11__/* .WEB_DESC */ .a0
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "twitter:image",
                        content: src_constants_layout__WEBPACK_IMPORTED_MODULE_11__/* .IMAGE_DEFAULT */ .TH
                    }),
                    !(0,src_utils_device__WEBPACK_IMPORTED_MODULE_14__/* .useDesktop */ .Ln)() && !lodash__WEBPACK_IMPORTED_MODULE_3___default().isEmpty(dataAdsHeader) ? (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(dataAdsHeader === null || dataAdsHeader === void 0 ? void 0 : dataAdsHeader.header_mobile)) : "",
                    (0,src_utils_device__WEBPACK_IMPORTED_MODULE_14__/* .useDesktop */ .Ln)() && !lodash__WEBPACK_IMPORTED_MODULE_3___default().isEmpty(dataAdsHeader) ? (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(dataAdsHeader === null || dataAdsHeader === void 0 ? void 0 : dataAdsHeader.header_desktop)) : "",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                        async: true,
                        type: "text/javascript",
                        src: "https://securepubads.g.doubleclick.net/tag/js/gpt.js"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                        type: "text/javascript",
                        dangerouslySetInnerHTML: {
                            __html: "var googletag = googletag || {}; window.googletag.cmd = googletag.cmd || [];"
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                        type: "text/javascript",
                        dangerouslySetInnerHTML: {
                            __html: '\n                __th_page="วิดีโอ";\n              '
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: '\n                {\n                  "@context": "https://schema.org",\n                  "@type": "WebSite",\n                  "name": "'.concat(src_constants_layout__WEBPACK_IMPORTED_MODULE_11__/* .WEB_NAME */ .Ey, '",\n                  "url": "').concat(src_constants_layout__WEBPACK_IMPORTED_MODULE_11__/* .WEB_URL.WEB */ .h$.WEB, '",\n                  "description": "').concat(articleDescriptionSeo, '",\n                  "sameAs": [\n                    "').concat(src_constants_layout__WEBPACK_IMPORTED_MODULE_11__/* .WEB_URL.FACEBOOK */ .h$.FACEBOOK, '",\n                    "').concat(src_constants_layout__WEBPACK_IMPORTED_MODULE_11__/* .WEB_URL.YOUTUBE */ .h$.YOUTUBE, '",\n                    "').concat(src_constants_layout__WEBPACK_IMPORTED_MODULE_11__/* .WEB_URL.INSTAGRAM */ .h$.INSTAGRAM, '"\n                  ],\n                  "potentialAction": {\n                    "@type": "SearchAction",\n                    "target": "').concat(src_constants_layout__WEBPACK_IMPORTED_MODULE_11__/* .WEB_URL.WEB */ .h$.WEB, 'search?q={search_term_string}",\n                    "query-input": "required name=search_term_string"\n                  }\n                }\n              ')
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: '\n              {\n                    "@context": "http://schema.org",\n                    "@type": "WebPage",\n                    "name": "วิดีโอ",\n                    "description": "'.concat(articleDescriptionSeo, '",\n                    "publisher": {\n                      "@type": "ProfilePage",\n                      "name": "').concat(src_constants_layout__WEBPACK_IMPORTED_MODULE_11__/* .WEB_NAME */ .Ey, '"\n                    }\n                  }\n                  ')
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: '\n              {\n                "@context": "http://schema.org",\n                "@type": "BreadcrumbList",\n                "itemListElement": "[\n                  {\n                      "@type": "ListItem",\n                      "position": 1,\n                      "name": "หน้าแรก",\n                      "item": "'.concat(src_constants__WEBPACK_IMPORTED_MODULE_10__/* .APP_URL */ .FX, '"\n                    },\n                    {\n                      "@type": "ListItem",\n                      "position": 2,\n                      "name": "วิดีโอ",\n                      "item": "').concat(src_constants__WEBPACK_IMPORTED_MODULE_10__/* .APP_URL */ .FX, '/live/video"\n                    }\n                  ]"\n                  \n                }\n                ')
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_layouts__WEBPACK_IMPORTED_MODULE_1__["default"], {
                sessionSevId: sessionSevId,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "container mb-5",
                    style: {
                        filter: src_constants__WEBPACK_IMPORTED_MODULE_10__/* .SHOW_COMMEMORATE */ .WT === "true" ? "grayscale(0.7)" : "unset"
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "row",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "col-12",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "category-wrapper",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                            className: "breadcrumb",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                        href: "/",
                                                        children: "หน้าแรก"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                        href: "/live/video",
                                                        children: "วีดีโอ"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                            className: "heading-title",
                                            children: "วิดีโอ"
                                        })
                                    ]
                                })
                            })
                        }),
                        !lodash__WEBPACK_IMPORTED_MODULE_3___default().isEmpty(dataConcat4) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "row",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_sections_section_video_sec_full_h__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                        data: dataConcat4.slice(0, 5),
                                        //! DATALAYER
                                        eventDataLayer: {
                                            type: src_utils_datalayer_send_datalayer__WEBPACK_IMPORTED_MODULE_13__/* .DATALAYER_TYPE.TRACK_POSITION */ .$7.TRACK_POSITION,
                                            router: router === null || router === void 0 ? void 0 : router.pathname,
                                            section: "Most Watched",
                                            position: "ใต้:header",
                                            data: {
                                                heading: "Most Watched"
                                            }
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "row mt-4 card-category",
                                    children: dataConcat4.slice(5).map(function(item, index) {
                                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "col-6 col-md-4 col-lg-3",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_cards_video_card_v__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                data: item,
                                                path: "/live/".concat(item === null || item === void 0 ? void 0 : item.section.en, "/").concat(item.id),
                                                //! DATALAYER
                                                eventDataLayer: {
                                                    type: src_utils_datalayer_send_datalayer__WEBPACK_IMPORTED_MODULE_13__/* .DATALAYER_TYPE.TRACK_POSITION */ .$7.TRACK_POSITION,
                                                    router: router === null || router === void 0 ? void 0 : router.pathname,
                                                    section: "วิดีโอทั้งหมด",
                                                    position: "ใต้:Most Watched",
                                                    data: {
                                                        title: item.title,
                                                        heading: "วิดีโอทั้งหมด",
                                                        index: index + 1
                                                    }
                                                }
                                            })
                                        }, index);
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (PageVideoCategory);


/***/ }),

/***/ 62732:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_icons_fa__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52091);
/* harmony import */ var src_utils_datalayer_send_datalayer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34892);
/* harmony import */ var src_utils_helper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39334);





var CardV = function(param) {
    var data = param.data, path = param.path, _setBackground = param.setBackground, setBackground = _setBackground === void 0 ? false : _setBackground, eventDataLayer = param.eventDataLayer;
    var ref;
    // console.log('VDO-cardV', data);
    var dateUpdate = (0,src_utils_helper__WEBPACK_IMPORTED_MODULE_2__/* .useDateUpdate */ .WR)(data === null || data === void 0 ? void 0 : data.published_at);
    var category = (data === null || data === void 0 ? void 0 : data.section) ? data === null || data === void 0 ? void 0 : (ref = data.section) === null || ref === void 0 ? void 0 : ref.th : "ข่าว";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            href: path,
            //! DATALAYER
            onClick: function() {
                return (0,src_utils_datalayer_send_datalayer__WEBPACK_IMPORTED_MODULE_1__/* .sendDataLayerGlobal */ .dE)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, eventDataLayer));
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "card-wrapper",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "card-video-v",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "position-absolute button-card-video-v",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_4__/* .FaPlay */ .gmG, {
                                className: "card-video-v-icon"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "card-v-thumb",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "resolution-image",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: "".concat(data.image),
                                    alt: data.title
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "video-info ".concat(setBackground && "--set-bg"),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    children: data.title
                                }),
                                data.description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "blurb",
                                    children: data.description
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "video-duration"
                                }),
                                data.published_at && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                    className: "video-date",
                                    children: [
                                        " | ",
                                        dateUpdate
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CardV);


/***/ }),

/***/ 4263:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ sec_full_h; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-icons/bs/index.mjs
var bs = __webpack_require__(78633);
// EXTERNAL MODULE: ./node_modules/react-icons/fa/index.mjs
var fa = __webpack_require__(52091);
// EXTERNAL MODULE: ./src/utils/datalayer/send-datalayer.js
var send_datalayer = __webpack_require__(34892);
;// CONCATENATED MODULE: ./src/components/cards-video/card-h.js




var CardH = function(param) {
    var data = param.data, number = param.number, eventDataLayer = param.eventDataLayer;
    var ref;
    var category = (data === null || data === void 0 ? void 0 : data.section) ? data === null || data === void 0 ? void 0 : (ref = data.section) === null || ref === void 0 ? void 0 : ref.th : "ข่าว";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "card-video-h",
        //! DATALAYER
        onClick: function() {
            return (0,send_datalayer/* sendDataLayerGlobal */.dE)((0,_object_spread/* default */.Z)({}, eventDataLayer));
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "video-number",
                children: number
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "play-card-live",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(fa/* FaPlay */.gmG, {
                        className: "position-absolute button-card-live"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "box-live",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: "video-thumbnail",
                            src: data === null || data === void 0 ? void 0 : data.image,
                            alt: data === null || data === void 0 ? void 0 : data.title
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "video-info",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        children: data === null || data === void 0 ? void 0 : data.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "d-flex video-meta",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "video-duration",
                                    children: category
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "video-remore",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: data.link,
                                        children: " อ่านต่อ..."
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var card_h = (CardH);

// EXTERNAL MODULE: ./src/constants/index.js
var constants = __webpack_require__(15072);
// EXTERNAL MODULE: ./src/utils/contents/get-image.js
var get_image = __webpack_require__(14433);
;// CONCATENATED MODULE: ./src/components/sections/section-video/sec-full-h.js








var SecFullH = function(param) {
    var data = param.data, _sectionH = param.sectionH, sectionH = _sectionH === void 0 ? false : _sectionH, eventDataLayer = param.eventDataLayer;
    var ref = (0,react.useState)({
        type_video: "",
        video_src: ""
    }), defalutData = ref[0], setDefalutData = ref[1];
    var ref1 = (0,react.useState)(0), counter = ref1[0], setCounter = ref1[1];
    if ((data === null || data === void 0 ? void 0 : data.length) > 0 && (defalutData === null || defalutData === void 0 ? void 0 : defalutData.video_src) === "") {
        var ref2, ref3;
        setDefalutData({
            type_video: (ref2 = data[0]) === null || ref2 === void 0 ? void 0 : ref2.type_video,
            video_src: (ref3 = data[0]) === null || ref3 === void 0 ? void 0 : ref3.video_src
        });
    }
    // console.log('SecFullH', defalutData);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: (data === null || data === void 0 ? void 0 : data.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "section-wrapper",
            style: {
                filter: constants/* SHOW_COMMEMORATE */.WT === "true" ? "grayscale(0.7)" : ""
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "row",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-12 video-player ".concat(sectionH ? "--small" : "col-md-8"),
                        children: (data === null || data === void 0 ? void 0 : data.length) > 0 && (0,get_image/* getFeatureImage */.k)(defalutData)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-12 ".concat(sectionH ? "" : "col-md-4", " card-wrapper"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "playlist-head",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "playlist-head-icon",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bs/* BsCaretRight */.E8f, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        children: "Most Watched"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "videos-number",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                children: [
                                                    " ",
                                                    counter + 1,
                                                    " "
                                                ]
                                            }),
                                            " / ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                children: [
                                                    " ",
                                                    data === null || data === void 0 ? void 0 : data.length,
                                                    " "
                                                ]
                                            }),
                                            " Videos"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "video-playlists playlist-custom-scroll --vertical",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    children: (data === null || data === void 0 ? void 0 : data.length) > 0 && data.map(function(item, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "w-100 ".concat(counter === index ? "active" : ""),
                                            onClick: function() {
                                                setDefalutData({
                                                    type_video: item.type_video,
                                                    video_src: item.video_src
                                                });
                                                setCounter(index);
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(card_h, {
                                                data: item,
                                                number: index + 1,
                                                //! DATALAYER
                                                eventDataLayer: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, eventDataLayer), {
                                                    data: (0,_object_spread/* default */.Z)({
                                                        title: item.title,
                                                        index: index + 1
                                                    }, eventDataLayer.data)
                                                })
                                            })
                                        }, index);
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var sec_full_h = (SecFullH);


/***/ }),

/***/ 38864:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ey": function() { return /* binding */ WEB_NAME; },
/* harmony export */   "Nt": function() { return /* binding */ WEB_LOGO; },
/* harmony export */   "Pc": function() { return /* binding */ STATIC_FILE; },
/* harmony export */   "TH": function() { return /* binding */ IMAGE_DEFAULT; },
/* harmony export */   "V5": function() { return /* binding */ SOCIAL_LIST; },
/* harmony export */   "a0": function() { return /* binding */ WEB_DESC; },
/* harmony export */   "h$": function() { return /* binding */ WEB_URL; },
/* harmony export */   "kG": function() { return /* binding */ WEB_KEYWORD; },
/* harmony export */   "qN": function() { return /* binding */ WEB_TITLE; },
/* harmony export */   "zK": function() { return /* binding */ IMAGE_NAME; }
/* harmony export */ });
/* unused harmony export ADDRESS_ORG */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_icons_bs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78633);
/* harmony import */ var react_icons_fa__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52091);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15072);




/* -------------------------------------------------------------------------- */ /*                                   HEADER                                   */ /* -------------------------------------------------------------------------- */ var IMAGE_NAME = "logo-192.png"; // logo-192.png
var IMAGE_DEFAULT = "".concat(src_constants__WEBPACK_IMPORTED_MODULE_1__/* .APP_IMG */ .T, "/default.jpg"); // default image
var WEB_TITLE = "ข่าวด่วน ข่าวล่าสุด ข่าววันนี้ วิเคราะห์ข่าวเศรษฐกิจ โดยกรุงเทพธุรกิจ";
var WEB_DESC = "กรุงเทพธุรกิจออนไลน์ นำเสนอข่าววันนี้ ข่าวด่วน ข่าวล่าสุดทั้งหมด เกี่ยวกับข่าวธุรกิจ ข่าวการเงิน ข่าวการค้า วิเคราะห์ข่าวเศรษฐกิจ ข่าวการลงทุน เพื่อการตัดสินใจอย่างมืออาชีพ";
var WEB_KEYWORD = "อ่านข่าวออนไลน์, กรุงเทพธุรกิจ, ข่าวเด่นประจำวัน, ข่าวโซเซียล, ข่าวธุรกิจ, การเงิน, เศรษฐกิจต่างประเทศ, คลิปข่าว, ข่าวบันเทิง";
var WEB_NAME = "bangkokbiznews";
var WEB_LOGO = "logo.png";
// export const TWITTER = {
//   HANDLE: 'กรุงเทพธุรกิจ',
//   SITE: '@ktnewsonline'
// };
var STATIC_FILE = {
    FB_APP_ID: "192332974272649",
    FB_PAGES: "135182934814",
    ICON_LOGO: "logo.svg",
    ICON_MASK: "bangkokbiznews.png",
    ICON_FAV: "favicon.ico",
    ICON_APPLE: "apple-touch-icon.png"
};
/* -------------------------------------------------------------------------- */ /*                                   FOOTER                                   */ /* -------------------------------------------------------------------------- */ var WEB_URL = {
    WEB: "".concat(src_constants__WEBPACK_IMPORTED_MODULE_1__/* .APP_URL */ .FX, "/"),
    FACEBOOK: "https://www.facebook.com/bangkokbiznews",
    TWITTER: "https://twitter.com/ktnewsonline",
    YOUTUBE: "https://www.youtube.com/channel/UCwAoYpzi-LmKhRXlW4bMdBA",
    LINE: "https://line.me/R/ti/p/%40rvb8351i",
    INSTAGRAM: "https://www.instagram.com/bangkokbiznews/"
};
var ADDRESS_ORG = {
    CONTENT: "บริษัท กรุงเทพธุรกิจ มีเดีย จำกัด 1858/126 ชั้นที่ 30 ถนนเทพรัตน แขวงบางนาใต้ เขตบางนา",
    PROVINCE: "กรุงเทพฯ",
    REGION: "TH",
    POSTCODE: "10260",
    COUNTRY: "THAILAND"
};
var SOCIAL_LIST = [
    {
        id: 1,
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_2__/* .FaFacebookF */ .tBk, {
            id: "facebook",
            size: 16
        }),
        link: WEB_URL.FACEBOOK,
        name: "facebook",
        className: "icon-facebook"
    },
    {
        id: 2,
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_bs__WEBPACK_IMPORTED_MODULE_3__/* .BsTwitterX */ .AMt, {
            id: "x",
            size: 16
        }),
        link: WEB_URL.TWITTER,
        name: "x",
        className: "icon-x"
    },
    {
        id: 3,
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_bs__WEBPACK_IMPORTED_MODULE_3__/* .BsLine */ .GF9, {
            id: "line",
            size: 16
        }),
        link: WEB_URL.LINE,
        name: "line",
        className: "icon-line"
    }
];


/***/ }),

/***/ 14433:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ getFeatureImage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var src_components_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84334);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15072);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(186);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  .embed-dailymotion {\n    width: 100%;\n    aspect-ratio: 16 / 9;\n    /* display: flex;\n    align-items: center;\n    justify-content: center; */\n    .dailymotion-player-root {\n      position: unset !important;\n    }\n    .resolution-video,\n    .resolution-dailymotion {\n      width: 100%;\n      height: 100%;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





// import styled from 'styled-components';
var getFeatureImage = function(_data) {
    var _showImg = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, _priority = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, _ignoreLazy = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    if (lodash__WEBPACK_IMPORTED_MODULE_2___default().isEmpty(_data)) return null;
    if (_showImg) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_image__WEBPACK_IMPORTED_MODULE_3__["default"], {
            image: _data === null || _data === void 0 ? void 0 : _data.image,
            title: _data === null || _data === void 0 ? void 0 : _data.title,
            ignoreLazy: _ignoreLazy,
            type: "FEATURE_IMAGE",
            width: 750,
            height: 422,
            loading: _priority ? "eager" : "lazy",
            fetchPriority: _priority ? "high" : "low"
        });
    }
    switch(_data === null || _data === void 0 ? void 0 : _data.type_video){
        case "0":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "embed-responsive embed-responsive-16by9",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("iframe", {
                    src: "".concat("".concat(src_constants__WEBPACK_IMPORTED_MODULE_4__/* .APP_IMG */ .T, "/").concat(_data === null || _data === void 0 ? void 0 : _data.video_src), "?autoplay=1")
                })
            });
        case "1":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(EmbdedWrapper, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    className: "embed-dailymotion",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        // className='embed-dailymotion'
                        dangerouslySetInnerHTML: {
                            __html: "\n              <script\n              defer\n              type='text/javascript'\n              src='".concat(src_constants__WEBPACK_IMPORTED_MODULE_4__/* .NEXT_DAILYMOTION_ID */ .pY, "'\n              data-video=").concat(_data === null || _data === void 0 ? void 0 : _data.video_src, "\n              ></script>")
                        }
                    })
                })
            });
        case "2":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "embed-responsive embed-responsive-16by9",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("iframe", {
                    src: "".concat(_data === null || _data === void 0 ? void 0 : _data.video_src, "?autoplay=1")
                })
            });
        default:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_image__WEBPACK_IMPORTED_MODULE_3__["default"], {
                className: "border-radius",
                image: _data === null || _data === void 0 ? void 0 : _data.image,
                title: _data === null || _data === void 0 ? void 0 : _data.title,
                ignoreLazy: _ignoreLazy,
                type: "FEATURE_IMAGE",
                class1: "br-8",
                width: 750,
                height: 422,
                loading: _priority ? "eager" : "lazy",
                fetchPriority: _priority ? "high" : "low"
            });
    }
};
// const EmbdedWrapper = styled.div`
//   position: absolute;
//   display: block;
//   width: 100%;
//   top: 0;
//   overflow: hidden;
//   .embed-dailymotion {
//     iframe {
//       width: 100%;
//       height: 480px;
//       @media (max-width: 500px) {
//         height: 220px;
//       }
//     }
//   }
// `;
var EmbdedWrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div(_templateObject());


/***/ }),

/***/ 51148:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97582);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31955);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15072);
/* eslint-disable no-unused-vars */ 





function useUser() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({}), result = ref[0], setResult = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true), loading = ref1[0], setLoading = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), error = ref2[0], setError = ref2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var isLogin = js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("login-state");
        var cookies = js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("login-data");
        var getUser = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
                var response, _tmp, _tmp1, res, _tmp2, _tmp3, error;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                5,
                                6,
                                7
                            ]);
                            _tmp = {};
                            return [
                                4,
                                fetch("/api/auth/me", (_tmp.method = "GET", _tmp.headers = {
                                    "Content-Type": "application/json"
                                }, _tmp))
                            ];
                        case 1:
                            response = _state.sent();
                            if (!(!response.ok || response.status === 204 || response.statusText === "No Content")) return [
                                3,
                                2
                            ];
                            js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].remove */ .Z.remove("login-state");
                            _tmp1 = {};
                            setResult(_tmp1);
                            return [
                                3,
                                4
                            ];
                        case 2:
                            return [
                                4,
                                response.json()
                            ];
                        case 3:
                            res = _state.sent();
                            _tmp2 = {};
                            js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].set */ .Z.set("login-data", res, (_tmp2.secure = true, _tmp2.expires = Number(src_constants__WEBPACK_IMPORTED_MODULE_3__/* .NEXT_PUBLIC_LOGIN_COOKIE_DATE */ .B6), _tmp2)); //, { expires: 1, sameSite: 'strict', secure: true, httpOnly: true }
                            _tmp3 = {};
                            setResult((_tmp3.user = res, _tmp3));
                            _state.label = 4;
                        case 4:
                            return [
                                3,
                                7
                            ];
                        case 5:
                            error = _state.sent();
                            setError(error);
                            return [
                                3,
                                7
                            ];
                        case 6:
                            setLoading(false);
                            return [
                                7
                            ];
                        case 7:
                            return [
                                2
                            ];
                    }
                });
            });
            return function getUser() {
                return _ref.apply(this, arguments);
            };
        }();
        if (!lodash__WEBPACK_IMPORTED_MODULE_1___default().isEmpty(isLogin) && !lodash__WEBPACK_IMPORTED_MODULE_1___default().isEmpty(cookies)) {
            var cook = js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("login-data");
            setResult({
                user: cook
            });
        } else if (!lodash__WEBPACK_IMPORTED_MODULE_1___default().isEmpty(isLogin) && lodash__WEBPACK_IMPORTED_MODULE_1___default().isEmpty(cookies)) {
            getUser();
        }
    }, []);
    return result;
}
/* harmony default export */ __webpack_exports__["Z"] = (useUser);


/***/ }),

/***/ 11163:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(90387)


/***/ }),

/***/ 31955:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ api; }
/* harmony export */ });
/*! js-cookie v3.0.5 | MIT */
/* eslint-disable no-var */
function assign (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      target[key] = source[key];
    }
  }
  return target
}
/* eslint-enable no-var */

/* eslint-disable no-var */
var defaultConverter = {
  read: function (value) {
    if (value[0] === '"') {
      value = value.slice(1, -1);
    }
    return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
  },
  write: function (value) {
    return encodeURIComponent(value).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    )
  }
};
/* eslint-enable no-var */

/* eslint-disable no-var */

function init (converter, defaultAttributes) {
  function set (name, value, attributes) {
    if (typeof document === 'undefined') {
      return
    }

    attributes = assign({}, defaultAttributes, attributes);

    if (typeof attributes.expires === 'number') {
      attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
    }
    if (attributes.expires) {
      attributes.expires = attributes.expires.toUTCString();
    }

    name = encodeURIComponent(name)
      .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
      .replace(/[()]/g, escape);

    var stringifiedAttributes = '';
    for (var attributeName in attributes) {
      if (!attributes[attributeName]) {
        continue
      }

      stringifiedAttributes += '; ' + attributeName;

      if (attributes[attributeName] === true) {
        continue
      }

      // Considers RFC 6265 section 5.2:
      // ...
      // 3.  If the remaining unparsed-attributes contains a %x3B (";")
      //     character:
      // Consume the characters of the unparsed-attributes up to,
      // not including, the first %x3B (";") character.
      // ...
      stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
    }

    return (document.cookie =
      name + '=' + converter.write(value, name) + stringifiedAttributes)
  }

  function get (name) {
    if (typeof document === 'undefined' || (arguments.length && !name)) {
      return
    }

    // To prevent the for loop in the first place assign an empty array
    // in case there are no cookies at all.
    var cookies = document.cookie ? document.cookie.split('; ') : [];
    var jar = {};
    for (var i = 0; i < cookies.length; i++) {
      var parts = cookies[i].split('=');
      var value = parts.slice(1).join('=');

      try {
        var found = decodeURIComponent(parts[0]);
        jar[found] = converter.read(value, found);

        if (name === found) {
          break
        }
      } catch (e) {}
    }

    return name ? jar[name] : jar
  }

  return Object.create(
    {
      set,
      get,
      remove: function (name, attributes) {
        set(
          name,
          '',
          assign({}, attributes, {
            expires: -1
          })
        );
      },
      withAttributes: function (attributes) {
        return init(this.converter, assign({}, this.attributes, attributes))
      },
      withConverter: function (converter) {
        return init(assign({}, this.converter, converter), this.attributes)
      }
    },
    {
      attributes: { value: Object.freeze(defaultAttributes) },
      converter: { value: Object.freeze(converter) }
    }
  )
}

var api = init(defaultConverter, { path: '/' });
/* eslint-enable no-var */




/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [601,9774,2888,179], function() { return __webpack_exec__(11994); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);